import { CircularProgress } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";
import styled from "styled-components";

const LoadingWrapper = styled.div`
    display: flex;
    width: 100%;
    height: 100vh;
    justify-content: center;
    align-items: center;
`;
const LoadingComponent: FC<PropsWithChildren> = () => (
    <LoadingWrapper>
        <CircularProgress />
    </LoadingWrapper>
);

export default LoadingComponent;
